import { targetingTypes } from '../../../LineItemDv360Create/fields'

export const getLineItemLanguages = targeting => {
  return targeting
    .filter(item => item.type === targetingTypes.TARGETING_TYPE_LANGUAGE)
    .map(item => ({ ...item, label: item.display_name, value: item.targeting_option_id }))
}
